module.exports = __webpack_public_path__ + "img/qrcode-support.96f04fa8.png";